import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { EnvironmentBase } from '@definitiv-packages/angular-dba-library';
import { AngularFormsLibraryModule } from '@definitiv-packages/angular-forms-library';

import { ProjectEnvironment, LibraryModule } from '../../../roofsafetymanagement-library/src/public-api';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DebtorListViewComponent } from './views/debtor-list-view/debtor-list-view.component';
import { ObjectServiceViewComponent } from './views/object-service-view/object-service-view.component';

import { DebtorViewComponent } from './views/debtor-view/debtor-view.component';
import { ObjectViewComponent } from './views/object-view/object-view.component'; 
import { IosInstallDialogComponent } from './dialogs/ios-install-dialog/ios-install-dialog.component';
import { TodosViewComponent } from './views/todos-view/todos-view.component';
import { SafetypointVerwaltungMenuComponent } from './views/safetypoint-verwaltung-menu/safetypoint-verwaltung-menu.component';
import { SafetypointSucheViewComponent } from './views/safetypoint-suche-view/safetypoint-suche-view.component';
import { SafetypointSucheComponent } from './components/safetypoint-suche/safetypoint-suche.component';


@NgModule({
  declarations: [
    AppComponent,
    DebtorListViewComponent,
    DebtorViewComponent,
    ObjectViewComponent,
    ObjectServiceViewComponent,    
    IosInstallDialogComponent,
    TodosViewComponent,

    SafetypointVerwaltungMenuComponent,
    SafetypointSucheViewComponent,
    SafetypointSucheComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LibraryModule,
    AngularFormsLibraryModule,
    DragDropModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: EnvironmentBase, useValue: environment },
    { provide: ProjectEnvironment, useValue: environment },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
